<template>
  <div class="mb-2 flex shrink-0 items-center px-4 py-2">
    <div
      v-if="!hideBack"
      class="shrink-0 items-center pr-2"
    >
      <DialogButtonClose @click="onClose" />
    </div>
    <PageTitle class="flex-1">
      <slot />
    </PageTitle>
    <slot name="extra" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  hideBack?: boolean
}>()

const emit = defineEmits<{
  (event: "close"): void
}>()

const onClose = () => {
  emit("close")
}
</script>
